// Detect an HLS playlist URL (.m3u8, optionally followed by a query or hash).
export function isHlsUrl(url) {
  return typeof url === "string" && /\.m3u8(\?|#|$)/i.test(url);
}

// Parse the "#t=<seconds>" media-fragment that the resume-cookie / deep-link
// logic appends to a URL, returning the start time in seconds (0 when absent
// or invalid). Used to seek HLS playback, where the #t= fragment can't be relied
// on the way it is for a direct file <src>.
export function parseStartSeconds(urlTimestamp) {
  if (!urlTimestamp) return 0;
  const match = String(urlTimestamp).match(/#t=(\d+(?:\.\d+)?)/);
  if (!match) return 0;
  const seconds = Number(match[1]);
  return Number.isFinite(seconds) && seconds > 0 ? seconds : 0;
}

// True for Safari on macOS and for every browser on iPhone/iPad (all use Apple's
// WebKit engine there). These play HLS reliably with Apple's built-in player,
// which also keeps lock-screen/background playback and AirPlay working.
// Chromium browsers (Chrome, Edge, Opera, Chromebooks) and Firefox return false —
// they use hls.js, since Chrome's built-in HLS player can stall on some versions.
export function isAppleWebKitBrowser(
  nav = typeof navigator !== "undefined" ? navigator : null
) {
  if (!nav || typeof nav.userAgent !== "string") return false;
  const ua = nav.userAgent;
  const isIOS =
    /iPhone|iPad|iPod/.test(ua) ||
    // iPadOS reports itself as a Mac; touch support gives it away.
    (/Macintosh/.test(ua) && nav.maxTouchPoints > 1);
  const isDesktopSafari =
    /Version\/[\d.]+.*Safari\//.test(ua) &&
    !/Chrome|Chromium|CriOS|Edg|OPR|Firefox|FxiOS|Android/.test(ua);
  return isIOS || isDesktopSafari;
}
